export default __webpack_public_path__ + "static/media/Revenue_pro_services_top_line.407c2db2.xlsx";